import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DatePicker, MenuItem, RaisedButton, SelectField } from 'material-ui';
import { asyncStart, asyncEnd, showFeedback } from '../actions/application';
import List from '../screens/list';
import api from '../utility/api';

function validDate(date) {
  let dateString = '';
  if (typeof date === 'number') {
    dateString = new Date(date);
  }
  return Date.parse(date)
    || (new Date(dateString)).toString() !== 'Invalid Date';
}

function formatTime(date) {
  if (validDate(date)) {
    const value = new Date(date);
    return value.toLocaleTimeString();
  }
  return date;
}

class Attendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doctors: [],
      attendances: [],
      start: '',
      end: ''
    };
  }

  componentDidMount() {
    this.getDoctorsList();
  }

  getDoctorsList() {
    this.props.dispatch(asyncStart());
    api.getDoctors()
      .then(doctors => {
        this.props.dispatch(asyncEnd());
        this.setState({ doctors });
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({ message: error.message }));
      });
  }

  fetchAttendance() {
    const { selectedDoc, start, end } = this.state;
    this.props.dispatch(asyncStart());
    api.getAttendances(selectedDoc.user.id, start, end)
      .then(attendances => {
        this.props.dispatch(asyncEnd());
        this.setState({ attendances });
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({ message: error.message }));
      });
  }

  onDoctorSelect(_, __, selectedDoc) {
    this.setState({ selectedDoc });
  }

  onDateChange(dateType, _, date) {
    this.setState({ [dateType]: date });
  }

  render() {
    const { doctors, selectedDoc, attendances, start, end } = this.state;
    const CC = (selectedDoc && selectedDoc.user &&
      (selectedDoc.user.operator && !selectedDoc.user.provider)) || false;
    return (
      <div className="app-container">
        <h1>Attendance</h1>
        <h4>Select a doctor</h4>
        <div>
          <div>
            <SelectField
              floatingLabelText="Doctor"
              value={selectedDoc}
              onChange={this.onDoctorSelect.bind(this)}
            >
              {doctors
              .sort((doctorA, doctorB) => {
                if (doctorA.user.name < doctorB.user.name) {
                  return -1;
                }
                else if (doctorA.user.name > doctorB.user.name) {
                  return 1;
                }
                else
                   return 0;
              })
              .map(d =>
                <MenuItem key={d.user_id} value={d} primaryText={d.user.name} />
              )}
            </SelectField>
            <DatePicker
              hintText="Start date"
              firstDayOfWeek={0}
              onChange={this.onDateChange.bind(this, 'start')}
            />
            <DatePicker
              hintText="End date"
              firstDayOfWeek={0}
              onChange={this.onDateChange.bind(this, 'end')}
            />
          </div>
          <div>
            <RaisedButton
              label="View Attendance"
              primary={true}
              disabled={!selectedDoc || !start || !end}
              onClick={this.fetchAttendance.bind(this)}
            />
          </div>
        </div>
        <div>
          <List reactTableProps={{
            columns: [
              {
                Header: 'Date',
                accessor: 'date'
              },
              {
                id: 'in_time',
                Header: 'In Time',
                accessor: a => formatTime(a.in_time)
              },
              {
                accessor: CC ? 'in_ip_address' : 'in_location',
                Header: CC ? 'In IP Address' : 'In Location'
              },
              {
                id: 'out_time',
                Header: 'Out Time',
                accessor: a => formatTime(a.out_time)
              },
              {
                accessor: CC ? 'out_ip_address' : 'out_location',
                Header: CC ? 'Out IP Address':  'Out Location'
              },
              {
                accessor: 'duration',
                Header: 'Duration',
              }
            ],
            noDataText: 'No attendance',
            data: attendances
          }}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(Attendance);



// WEBPACK FOOTER //
// ./src/containers/attendance.js